<template>
  <div class="orders-filters">
    <v-card tile>
      <v-toolbar color="red accent-2" dark>
        <v-toolbar-title>Filters</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="filterOpened = !filterOpened">
          <v-icon>{{filterOpened ? 'mdi-chevron-down' : 'mdi-chevron-up'}}</v-icon>
        </v-btn>
      </v-toolbar>
      <div v-if="filterOpened" class="px-5">
        <v-row align="center" class="ma-1">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="selectedNumber"
              placeholder="Number..."
              single-line
              dense
              prepend-icon="mdi-numeric-1-box-multiple-outline"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-dialog ref="dialog" v-model="modal" :return-value.sync="selectedDay" width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="selectedDay"
                  placeholder="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  dense
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="selectedDay" scrollable color="red accent-2">
                <v-spacer></v-spacer>
                <v-btn text color="red accent-2" @click="modal = false">Cancel</v-btn>
                <v-btn text color="red accent-2" @click="$refs.dialog.save(selectedDay)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row align="center" class="ma-1">
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedConcept"
              :items="concepts"
              item-value="uuid"
              item-text="label"
              menu-props="auto"
              placeholder="Concept..."
              hide-details
              prepend-icon="mdi-lightbulb-outline"
              single-line
              clearable
              dense
            >
              <template v-slot:item="props">
                <v-avatar size="36px" tile>
                  <v-img :src="props.item.logo" contain class="pa-2" />
                </v-avatar>
                <div class="mx-4">{{props.item.label}}</div>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedKitchen"
              :items="kitchens"
              item-value="uuid"
              item-text="id"
              menu-props="auto"
              placeholder="Kitchen..."
              hide-details
              prepend-icon="mdi-store"
              single-line
              clearable
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedPlatform"
              :items="platforms"
              item-value="uuid"
              item-text="label"
              menu-props="auto"
              placeholder="Platform..."
              hide-details
              prepend-icon="mdi-bike"
              single-line
              clearable
              dense
            >
              <template v-slot:item="props">
                <v-avatar size="36px" tile>
                  <v-img :src="props.item.logo" contain class="pa-2" />
                </v-avatar>
                <div class="mx-4">{{props.item.label}}</div>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedCountry"
              :items="countries"
              item-value="country_code"
              item-text="label"
              menu-props="auto"
              placeholder="Country..."
              hide-details
              prepend-icon="mdi-earth"
              single-line
              clearable
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center">
            <v-btn @click="search" class="mx-2" color="success">Search</v-btn>
            <v-btn @click="reset" class="mx-2" color="grey">Reset</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{snackbarMessage}}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    concepts: { type: Array },
    kitchens: { type: Array },
    platforms: { type: Array },
    countries: { type: Array },
  },
  data: () => {
    return {
      selectedNumber: null,
      selectedDay: null,
      selectedConcept: null,
      selectedKitchen: null,
      selectedPlatform: null,
      selectedCountry: null,
      modal: false,
      filterOpened: true,
      snackbar: false,
      snackbarMessage: "",
    };
  },
  methods: {
    search() {
      if (!(this.selectedNumber || this.selectedDay)) {
        this.snackbar = true;
        this.snackbarMessage = "Please select an order Number or a day";
      } else {
        this.$emit(
          "search",
          this.selectedNumber,
          this.selectedDay,
          this.selectedConcept,
          this.selectedKitchen,
          this.selectedPlatform,
          this.selectedCountry
        );
      }
    },
    reset() {
      this.selectedNumber = null;
      this.selectedDay = null;
      this.selectedConcept = null;
      this.selectedKitchen = null;
      this.selectedPlatform = null;
      this.selectedCountry = null;
    },
  },
};
</script>
